import React, { useState, useEffect } from "react";
import UserService from "../utils/userService";

const UserInfo = () => {
  const user = UserService.getUserData();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="user-details-container">
      <div className="search-container"></div> {/* TODO: Verify */}
      {windowWidth > 1000 && user && (
        <div className="user-info-container">
          <div>
            <div>
              Welcome, <strong>{user.name}</strong>
            </div>
            <div className="role-badge">{user.rolename}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
